module.exports = __webpack_public_path__ + "img/90waiyuanchedao.prt.73c50af8.jpg";